import React from 'react';
import styled from 'styled-components';

import FieldDisplayTypes from '../../../constants/FieldDisplayTypes';

import { hexToRGBA } from '../../../lib/colors';

import ThemeIcons from '../../../theme/Icons';

import Icon from '../../misc/Icon';

const StyledWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  transition: all 0.15s ease-in-out;
  border-radius: ${(props) => props.borderRadius}px;
  ${(props) => (!props.disabled ? `background: ${props.backgroundColor};` : '')}
  &:hover {
    ${(props) => (!props.disabled ? 'cursor: pointer;' : '')}
    ${(props) => (!props.disabled ? `background-color: ${props.backgroundColor};` : '')}
    ${(props) => (!props.disabled ? `border: 1px solid ${props.primaryColor};` : '')}
  }

`;

const StyledIconWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.fontColor};
  border-radius: ${(props) => props.borderRadius}px;
  border: ${(props) => props.border};
  svg {
    flex: 1;
    width: 100% !important;
    height: 100% !important;
  };
`;

const StyledShapeWrapper = styled.div`
  flex: 1;
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius}px;
  border: ${(props) => props.border};
`;

function SelectionField({

  id,

  displayType,
  value, //Should be a boolean value
  disabled,
  onChange,
  onFocus,

  //Styles
  fontColor,
  borderWidth,
  borderColor,
  borderRadius,
  backgroundColor,
  primaryColor

}) {

  let displayNode = null;

  if (value && displayType === FieldDisplayTypes.check) {
    displayNode = (
      <StyledIconWrapper
        data-testid={`${id}-selection-field-check-wrapper`}
        {...{
          fontColor,
          backgroundColor,
          borderRadius,
          border: `${borderWidth}px solid ${borderColor}`,
        }}
      >
        <Icon
          icon={ThemeIcons.fields.selectorCheck}
          color={fontColor}
          extraProps={{ 'data-testid': `${id}-selection-field-check` }}
        />
      </StyledIconWrapper>
    );
  } else if (value && displayType === FieldDisplayTypes.radio) {
    displayNode = (
      <StyledIconWrapper
        data-testid={`${id}-selection-field-radio-wrapper`}
        {...{
          fontColor,
          backgroundColor,
          borderRadius,
          border: `${borderWidth}px solid ${borderColor}`,
        }}
      >
        <Icon
          icon={ThemeIcons.fields.selectorRadio}
          color={fontColor}
          extraProps={{ 'data-testid': `${id}-selection-field-radio` }}
        />
      </StyledIconWrapper>
    );
  } else if (value && displayType === FieldDisplayTypes.square) {
    displayNode = (
      <StyledShapeWrapper
        data-testid={`${id}-selection-field-square`}
        {...{
          border: `3px solid ${fontColor}`,
          borderRadius: 3,
          backgroundColor: 'transparent',
        }}
      />
    );
  } else if (value && displayType === FieldDisplayTypes.circle) {
    displayNode = (
      <StyledShapeWrapper
        data-testid={`${id}-selection-field-circle`}
        {...{
          border: `3px solid ${fontColor}`,
          borderRadius: 100,
          backgroundColor: 'transparent',
        }}
      />
    );
  }

  return (
    <StyledWrapper
      {...{
        primaryColor,
        borderWidth,
        borderRadius,
        backgroundColor: hexToRGBA(primaryColor, '0.15'),
      }}
      disabled={disabled}
      data-testid={`${id}-selection-field`}
      onClick={() => {
        if (onFocus) onFocus();
        if (!disabled && onChange) onChange(!value);
      }}
    >
      {displayNode}
    </StyledWrapper>
  );
}

export default React.memo(SelectionField);
